export default __webpack_public_path__ + "static/media/error-payment.6d30a19b.svg";